import {WorkflowDispatchDefinitionResponseSchema} from '@github-ui/dotcom-schema/types/actions/v1/workflow_dispatch_definition'
import {useQuery} from '@github-ui/react-query'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'

type WorkflowDispatchRefKind = 'branch' | 'tag'

interface WorkflowDispatchDefinitionOptions {
  owner: string
  repo: string
  workflowPath: string
  selectedRef?: string
  selectedRefType?: WorkflowDispatchRefKind
  enabled?: boolean
}

/** Fetches the full workflow dispatch definition for the selected ref. */
export function useWorkflowDispatchDefinition({
  owner,
  repo,
  workflowPath,
  selectedRef,
  selectedRefType,
  enabled = true,
}: WorkflowDispatchDefinitionOptions) {
  // Dispatch inputs are ref-specific and authorization-sensitive; always fetch current server state.
  // eslint-disable-next-line @github-ui/github-monorepo/require-query-persister
  return useQuery({
    queryKey: ['workflow-dispatch-definition', owner, repo, workflowPath, selectedRefType ?? '', selectedRef ?? ''],
    enabled: enabled && Boolean(owner && repo && workflowPath),
    placeholderData: previousData => previousData,
    queryFn: () =>
      queryFnFetch(
        {
          routeId: 'actions-workflows',
          queryName: 'workflowDispatchDefinition',
          queryDeps: {
            pathname: `/${owner}/${repo}/actions/manual`,
            searchParams: {
              workflow: workflowPath,
              branch: selectedRefType === 'branch' ? selectedRef || null : null,
              tag: selectedRefType === 'tag' ? selectedRef || null : null,
            },
          },
        },
        {schema: WorkflowDispatchDefinitionResponseSchema},
      ),
  })
}
